<template>
  <div>
    <b-navbar id="header" type="light" variant="light" sticky>
      <b-navbar-nav class="mr-2">
        <b-button size="sm" variant="primary" @click="onBack()">
          <font-awesome-icon icon="chevron-left"/>
          Назад
        </b-button>
      </b-navbar-nav>
      <b-navbar-nav>
        <h4 class="mb-0">{{ title }}</h4>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-btn v-if="canEdit" size="sm" variant="success" :disabled="isBusy" @click="onCreate()">
          <b-spinner v-if="isBusy" small/>
          <font-awesome-icon icon="plus" class="mr-1"/>
          {{ createText }}
        </b-btn>
      </b-navbar-nav>
    </b-navbar>

    <b-navbar variant="light">
      <b-navbar-nav>
        <filters-drawer
          :query.sync="filters.query"
          :is-busy="isBusy"
          hide-search-button
          @submit="onSearch"
        />
      </b-navbar-nav>
    </b-navbar>

    <b-table
      id="catalogs_tables"
      ref="data_table"
      class="mb-0 text-small"
      selectable
      select-mode="single"
      selectedVariant="success"
      striped
      small
      responsive
      show-empty
      :empty-text="$t('message.common.emptyTable')"
      :busy="isBusy"
      :items="items"
      :fields="fields"
      no-provider-filtering
      no-provider-paging
      no-provider-sorting
      no-local-sorting
      @sort-changed="sortChanged"
      @row-dblclicked="onRowClicked"
      sticky-header
      head-variant="light"
    >
      <template #table-busy>
        <div class="text-center text-success my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Загрузка</strong>
        </div>
      </template>

      <template #cell(name)="row">
        <slot name="name-tag" :item="row.item">
          {{ row.item.name }}
        </slot>
      </template>

      <template #cell(color)="row">
        <b-badge pill :style="getBadgeStyle(row.item.color)" class="px-2 py-1">
          {{ row.item.color }}
        </b-badge>
      </template>

      <template #cell(active)="row">
        <font-awesome-icon v-if="!row.item.active" icon="times"/>
        <font-awesome-icon v-if="row.item.active" icon="check"/>
      </template>

      <template #cell(action)="row">
        <b-btn v-if="canEdit" size="sm" variant="primary" @click="onEdit(row.item)">
          <font-awesome-icon icon="edit"/>
        </b-btn>
        <b-btn v-else size="sm" variant="info" @click="onView(row.item)">
          <font-awesome-icon icon="eye"/>
        </b-btn>
      </template>
    </b-table>

    <pagination-footer
      :total-rows="totalRows"
      :per-page.sync="perPage"
      @page-click="onPagination"
      @per-page-change="onPerPageChange"
    />

    <router-view
      :key="$route.fullPath"
      @refresh="getItems"
      @modal-closed="onModalClosed"
    />

  </div>
</template>

<script>
import helpers from "../../utilites/helpers";
import FiltersDrawer from "../../utilites/commonUi/FiltersDrawer.vue";
import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";
import pageSearchService from "../../utilites/pageSearchService";

export default {
  name: 'Catalogs',
  components: { PaginationFooter, FiltersDrawer },
  mixins: [ helpers, pageSearchService ],
  props: {
    title: {type: String, required: true},
    createText: {type: String, required: true},
    fetchData: {type: Function, required: true},
    routeCreate: {type: String, required: true},
    routeEdit: {type: String, required: true},
    routeView: {type: String, required: true},
    routePath: {type: String, required: true},
    canEdit: { type: Boolean, required: true},
  },
  data() {
    return {
      items: [],
      isBusy: false,
      sortBy: 'id',
      sortDesc: true,
      filters: {
        query: '',
      },
      deleteRow: {
        id: null,
        name: ''
      },
      fields: [
        {
          key: 'id',
          sortable: true,
          class: 'catalog-id'
        },
        {
          key: 'name',
          label: "Название",
          sortable: true,
        },
        {
          key: 'color',
          label: "Цвет",
        },
        {
          key: 'active',
          label: "Активный",
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'action',
          label: "Действия",
          class: 'catalog-action'
        },
      ],
    };
  },
  async created() {
    const query = this.$route.query;

    if (query && query.query) {
      this.filters.query = query.query;
    }

    if (this.$route.hash) {
      this.currentPage = this.getPage(this.$route.hash);
    }

    await this.onSearch();
  },
  methods: {
    async getItems() {
      const data = {
        page: this.currentPage,
        size: this.perPage,
        query: this.filters.query,
        sortBy: [this.sortBy],
        sortDesc: [this.sortDesc],
      }

      this.isBusy = true;
      const result = await this.fetchData(data);
      this.isBusy = false;

      if (!result || !result.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        this.items = [];
        this.loading = false;
        return;
      }

      this.items = result.data.items;
      this.totalRows = result.data.total;
    },
    onCreate() {
      this.$router.push({ name: this.routeCreate }).catch((e) => {
        if (e.name === "permissions") {
          this.showToast('У Вас нет доступа выполнить это действие.', 'Нет доступа', 'danger');
        }
      });
    },
    onRowClicked(item) {
      if (this.canEdit) {
        this.onEdit(item);
      } else {
        this.onView(item);
      }
    },
    onEdit(item) {
      this.$router.push({ name: this.routeEdit, params: { id: item.id }}).catch((e) => {
        if (e.name === "permissions") {
          this.showToast('У Вас нет доступа выполнить это действие.', 'Нет доступа', 'danger');
        }
      });
    },
    onView(item) {
      this.$router.push({ name: this.routeView, params: { id: item.id }}).catch((e) => {
        if (e.name === "permissions") {
          this.showToast('У Вас нет доступа выполнить это действие.', 'Нет доступа', 'danger');
        }
      });
    },
    onModalClosed() {
      this.$router.replace({
        path: this.routePath,
        query: this.$route.query,
        hash: this.$route.hash,
      }).catch(()=>{});
    },
    onBack() {
      this.$router.push('/catalogs').catch(()=>{});
    },
  }
}
</script>

<style>
#catalogs_tables th {
  vertical-align: middle;
}

#catalogs_tables td {
  vertical-align: middle;
}

.catalog-id {
  padding-left: 10px !important;
  width: 60px;
  text-align: center;
}

.catalog-action {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/Catalogs.vue